<template>
	<div class="detail_body">

			<div class="cons fstock">
				<table class="tab_detail">
					<tr><th>工厂编码</th><td>{{sdata.factoryCode}}</td></tr>
          <tr><th>工厂描述</th><td>{{sdata.factoryDesc}}</td></tr>
          <tr><th>库存地编码</th><td>{{sdata.inventoryCode}}</td></tr>
          <tr><th>库存地描述</th><td>{{sdata.inventoryDesc}}</td></tr>
          <tr><th>默认库存地</th><td>{{sdata.isDefault ? "是" : "不是"}}</td></tr>
          <tr><th>是否允许MRP</th><td>{{sdata.isMrp ? "允许" : "不允许"}}</td></tr>
          <tr><th>是否允许负库存</th><td>{{sdata.isNegativeInventory ? "允许" : "不允许"}}</td></tr>
          <tr><th>维护状态</th><td>{{sdata.maintainStatus === 'X' ? "删除" : "正常"}}</td></tr>
				</table>
      </div>
	</div>
</template>

<script>
export default{
  props:{
    sdata:Object
  },
	created(){

	},
	methods:{
	}
}
</script>
<style>
  .fstock .tab_detail td{width: auto;}
</style>
